var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popular-destinations" }, [
    _c(
      "div",
      { staticClass: "popular-destinations__header" },
      [
        _vm._t("header"),
        _vm._v(" "),
        _c("div", { staticClass: "popular-destinations__nav" }, [
          _c(
            "button",
            {
              staticClass: "popular-destinations__nav__btn",
              on: { click: _vm.prevSlide }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 16 16"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M5.33331 2.66663L10.3795 7.71278C10.4187 7.74961 10.45 7.7941 10.4714 7.8435C10.4927 7.89288 10.5038 7.94613 10.5038 7.99996C10.5038 8.05379 10.4927 8.10704 10.4714 8.15642C10.45 8.20582 10.4187 8.25031 10.3795 8.28714L5.33331 13.3333"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "popular-destinations__nav__btn",
              on: { click: _vm.nextSlide }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 16 16"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M5.33331 2.66663L10.3795 7.71278C10.4187 7.74961 10.45 7.7941 10.4714 7.8435C10.4927 7.89288 10.5038 7.94613 10.5038 7.99996C10.5038 8.05379 10.4927 8.10704 10.4714 8.15642C10.45 8.20582 10.4187 8.25031 10.3795 8.28714L5.33331 13.3333"
                    }
                  })
                ]
              )
            ]
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "popular-destinations__body" }, [
      _vm.ready
        ? _c(
            "div",
            { staticClass: "popular-destinations__grid" },
            [
              _c(
                "carousel",
                {
                  ref: "carousel",
                  attrs: {
                    perPage: 1,
                    perPageCustom: _vm.perPageCustom,
                    "pagination-enabled": false
                  }
                },
                [_vm._t("slides")],
                2
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c841de7", { render: render, staticRenderFns: staticRenderFns })
  }
}